import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  ModuleWithProviders
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [ReactiveFormsModule, NgbModule, FontAwesomeModule],
  declarations: [],
  providers: [],
  exports: [FormsModule, CommonModule, NgbModule, FontAwesomeModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EntredaSharedModule {
  static forRoot(): ModuleWithProviders<EntredaSharedModule> {
    return {
      ngModule: EntredaSharedModule
    };
  }
}
